<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Customer Coords Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <b-form @submit.prevent="onSubmit">
      <b-form-group label="Name" :label-cols="3" class="mb-3">
        <b-form-input
          v-model="$v.form_data.name.$model"
          name="coord_name"
          type="text"
          class="form-control"
          placeholder="Coord Name"
          autocomplete="coord_name"
          :state="$v.form_data.name.$dirty && $v.form_data.name.$invalid ? false : null"
        />
      </b-form-group>

      <div class="mb-3">
        <MapboxMap :selected-customer-coord="form_data" mapHeight="500px" @location-selected="handleMarkerChange" />
      </div>

      <!-- validation error -->
      <b-row v-if="validationError">
        <b-col>
          <b-alert variant="danger" show>
            <i class="fa fa-exclamation-triangle" /> Please fill out all required fields.
          </b-alert>
        </b-col>
      </b-row>

      <b-row v-if="error">
        <b-col>
          <b-alert variant="danger" show>
            <i class="fa fa-exclamation-triangle" /> {{ error }}
          </b-alert>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button variant="success" block :disabled="submittingForm" @click="onSubmit">
            <i v-if="submittingForm" class="fal fa-spinner fa-spin" />
            <span v-else>
              Submit
            </span>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import MapboxMap from '@/components/shared/MapboxMap.vue'

export default {
  name: 'CustomerCoordForm',
  components: {
    MapboxMap
  },
  mixins: [validationMixin],
  props: {
    submittingForm: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    customer_coord: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      loading: false,

      form_data: {
        name: null,
        lat: null,
        long: null,
      },

      selected_customer_coord: null,

      validationError: false
    }
  },
  validations: {
    form_data: {
      name: { required },
      lat: { required },
      long: { required }
    }
  },
  mounted () {
    if (this.customer_coord) {
      this.form_data.name = this.customer_coord.name
      this.form_data.lat = this.customer_coord.lat
      this.form_data.long = this.customer_coord.long
    }
  },
  methods: {
    handleMarkerChange (lngLat) {
      if (lngLat && lngLat.lat && lngLat.long) {
        this.form_data.lat = lngLat.lat
        this.form_data.long = lngLat.long
      }
    },

    onSubmit () {
      this.validationError = false
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.validationError = true
        return
      }

      this.$emit('submit', this.form_data)
    }
  }
}
</script>
